module.exports = __webpack_public_path__ + "img/impresion.6a6cd271.jpg";